export var RequestMethods;
(function (RequestMethods) {
    RequestMethods["GET"] = "GET";
    RequestMethods["POST"] = "POST";
    RequestMethods["PUT"] = "PUT";
    RequestMethods["HEAD"] = "HEAD";
    RequestMethods["DELETE"] = "DELETE";
    RequestMethods["PATCH"] = "PATCH";
    RequestMethods["OPTIONS"] = "OPTIONS";
})(RequestMethods || (RequestMethods = {}));
//# sourceMappingURL=RequestMethods.js.map